import { useState } from 'react'
import { nodes as api } from '@/api/endpoints'
import { Err } from '@/components/Err'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

// 노드 제거 대화 상자(#269): 제목 · 결과 한 문장 · 이름 확인 입력 · 버튼 둘 — 노드 이름을 똑같이 쳐야 `제거` 가 열린다.
// 서버가 살아 있는 다른 멤버를 통해 클러스터에서 빼고 행을 숨긴다. 켜져 있거나 VM 이 남았으면 409 한 문장.
// 노드 상세·노드 카드의 오프라인 배지 메뉴와 검토 대기의 `제거` 칩이 같은 대화 상자를 연다.

export function NodeRemoveDialog({ open, nodeId, name, onClose, onRemoved }: { open: boolean; nodeId: string; name: string; onClose: () => void; onRemoved: () => void }) {
  return (
    <Dialog open={open} onOpenChange={(v) => (v ? undefined : onClose())}>
      <DialogContent aria-describedby={undefined}>{open ? <RemoveForm nodeId={nodeId} name={name} onClose={onClose} onRemoved={onRemoved} /> : null}</DialogContent>
    </Dialog>
  )
}

function RemoveForm({ nodeId, name, onClose, onRemoved }: { nodeId: string; name: string; onClose: () => void; onRemoved: () => void }) {
  const [typed, setTyped] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const confirmed = typed.trim() === name
  const remove = async () => {
    if (!confirmed) return
    setBusy(true)
    setError(null)
    try {
      await api.remove(nodeId)
      onRemoved()
    } catch (err) {
      setError(err)
      setBusy(false)
    }
  }
  return (
    <>
      <DialogHeader>
        <DialogTitle>{name} 제거</DialogTitle>
      </DialogHeader>
      <p className="text-[13px]">클러스터에서 빠지고 목록에서 사라집니다.</p>
      <div className="grid gap-1.5">
        <Label htmlFor="node-remove-name">이름 확인</Label>
        <Input id="node-remove-name" value={typed} placeholder={name} autoComplete="off" disabled={busy} onChange={(e) => setTyped(e.target.value)} />
      </div>
      <Err error={error} />
      <DialogFooter>
        <Button variant="outline" disabled={busy} onClick={onClose}>
          취소
        </Button>
        <Button variant="destructive" disabled={busy || !confirmed} onClick={() => void remove()}>
          {busy ? '제거 중' : '제거'}
        </Button>
      </DialogFooter>
    </>
  )
}
